(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-addons-hub"] && !Shopify.designMode) return;
  try {
    
(function(){
  var faqBtns = document.querySelectorAll('.faq-btn');
  faqBtns.forEach(function(b){
    b.addEventListener('click', function(){
      var p = this.nextElementSibling;
      var open = p.style.display === 'block';
      document.querySelectorAll('.addons-acc .panel').forEach(function(x){ x.style.display='none'; });
      if(!open) p.style.display = 'block';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
